import React, { useState } from 'react';
import PrematchContext from '../../../contexts/PrematchContext';
import { isSeoSettingsNoFollow } from '../../../data/seo/seoUtils';
import { useAbsolutePath } from '../../../data/seo/seoRouteUtils';
import { getConfiguration, getEncodedURI } from '../../../data/utils';
import MenuCompetitionItem from './MenuCompetitionItem';

function MenuCountryItem(props) {
    const conf = getConfiguration();
    const prematchContext = React.useContext(PrematchContext);
    const [isCollapsed, setIsCollapsed] = useState(true);

    function handleClick(e) {
        e.preventDefault();
        if (isCollapsed && prematchContext.selectedTournaments.length === 0) {
            prematchContext.openSelectionMenu(props.sportRef, props.id);
        }
        setIsCollapsed(!isCollapsed);
        e.stopPropagation();
    }

    function handleClickHref(url, e) {
        e.preventDefault();
    }

    // function getParentsUrlPath() {
    //     return [{'path':props.sportUrlPath,'suffix':props.sportUrlPathSuffix}];
    // }

    const absoluteCountryPath = useAbsolutePath(`${props.urlPath}${props.urlPathSuffix}`, null, props.urlPathSeo);
    const noFollow = isSeoSettingsNoFollow(props.urlPathSeoSettings);

    const icoCategory = props.categoryIcon;
    return (
        <div className="regione-widget">
            <div className={"elemento-competizioni-widget pointer toggle-nascondi-live tog-menu " + (isCollapsed ? "collapsed" : "")} data-target={`#menu-country-${props.id}`} onClick={handleClick}>
                <a href={getEncodedURI(absoluteCountryPath)} className={"nero"} onClick={handleClickHref.bind(this, absoluteCountryPath)} {...(noFollow ? {rel: 'nofollow'} : {})}>
                    <div className="paese-widget-sx">
                        <div className={`img-fluid img-flags ico-cat ${icoCategory}`}></div>
                        {props.descrizione}
                    </div> 
                </a>
                {props.isLive &&
                    <span className="live-badge"></span>
                }
                <span>{conf.iwh ? `(${props.tournamentsCountByFilter?.[prematchContext.temporalFilter] ?? props.tournamentsCount})` : props.tournamentsCountByFilter?.[prematchContext.currentFilter] ?? props.tournamentsCount}</span>
            </div>
            <div className={"competizione-sub collapse " + (!isCollapsed ? "show" : "")} id={`menu-country-${props.id}`}>
                {!isCollapsed && props.tournaments.map(tournament =>
                    <MenuCompetitionItem key={tournament.id} {...tournament} sportId={props.sportId} countryId={props.id} />
                )}
            </div>
        </div>
    );
}
    
export default MenuCountryItem;